import { Avatar, Box, Typography, styled } from "@mui/material";
import { INote } from "models/notes"
import moment from "moment";
import React from "react";

const UserAvatar = styled(Avatar)(({theme}) => ({
    backgroundColor: theme.palette.primary.main,
    width: '40px',
    height: '40px',
    fontSize: '20px',
    marginRight: '20px'
}));

const NoteUserDisplay = (props: { note: INote, avatar: boolean }) => {
    const { note, avatar } = props;

    return (
        <Box sx={{
            flexGrow: 1,
            display: 'flex',
            marginLeft: avatar ? '-60px' : 0,
            alignContent: 'center',
            alignItems: 'center'                
        }}>
            { avatar ? 
            <UserAvatar alt={ note.username }>
                { note.userInitials }
            </UserAvatar>
            : null }
            <b>{note.username}</b>
        </Box>
    );
};

const NoteDateDisplay = (props: { date: string}) => {    
    const dateDisplay = moment.utc(props.date).format('DD MMM YYYY');
    const timeDisplay = moment.utc(props.date).format('HH:mm UTC');

    return (<>
        <span style={{
            marginRight: '2em'
        }}>{dateDisplay}</span>
        {timeDisplay}
    </>);
};

type NoteHeadingProps = {
    note: INote;
    avatar?: boolean;
};

const NoteHeading: React.FC<NoteHeadingProps> = (props) => {
    const { note } = props;
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center',
            padding: props.avatar ? undefined : '8px',
            opacity: note.isDeleted ? '50%' : '100%'
        }}>
            <NoteUserDisplay note={note} avatar={props.avatar ?? false}/>
            <NoteDateDisplay date={note.createdOn}/>
        </Box>
    );
};

export default NoteHeading;